export const PAYMENT_ENDPOINT = `https://${process.env.NEXT_PUBLIC_PAYMENT_GATEWAY_DOMAIN_NAME}`;
